import React from 'react';

export default function EmptyCart() {
  return (
    <div className="emptyCartContainer">
      <div className="emptyCartRow">
        <div className="emptyCartCol">
          <h1 id="yourCartEmpty">Your Cart Is Currently Empty</h1>
        </div>
      </div>
    </div>
  )
}
